import { render, staticRenderFns } from "./cualificaciones-form.vue?vue&type=template&id=69818566&scoped=true"
import script from "./cualificaciones-form.vue?vue&type=script&lang=js"
export * from "./cualificaciones-form.vue?vue&type=script&lang=js"
import style0 from "./cualificaciones-form.vue?vue&type=style&index=0&id=69818566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69818566",
  null
  
)

export default component.exports